// Динамические title + favicon для разных разделов и ролей
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logoPng } from '../config/assets';

const FAVICONS = {
  menu: logoPng(),
  delivery: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="90">🚚</text></svg>',
  admin: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="90">⚙️</text></svg>',
  waiter: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="90">🤵</text></svg>',
  login: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="90">🔐</text></svg>',
  superadmin: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="90">👑</text></svg>',
};

function getMeta(pathname, user) {
  if (pathname.startsWith('/waiter-login')) return { title: 'Вход официанта', favicon: FAVICONS.waiter };
  if (pathname.startsWith('/login')) return { title: 'Вход', favicon: FAVICONS.login };
  if (pathname.startsWith('/superadmin')) return { title: 'Суперадмин', favicon: FAVICONS.superadmin };
  if (pathname.startsWith('/courier')) return { title: 'Курьер', favicon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="90">🚗</text></svg>' };
  if (pathname.startsWith('/kitchen')) return { title: 'Кухня — KDS', favicon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="90">🍳</text></svg>' };
  if (pathname.startsWith('/admin')) {
    if (user?.role === 'waiter') return { title: 'Заказы', favicon: FAVICONS.waiter };
    if (user?.role === 'superadmin' || user?.is_super_admin) return { title: 'Суперадмин', favicon: FAVICONS.superadmin };
    return { title: 'Панель управления', favicon: FAVICONS.admin };
  }
  if (pathname.startsWith('/pwa-courier')) {
    return { title: 'Курьер — установка PWA', favicon: FAVICONS.delivery };
  }
  if (pathname.startsWith('/delivery')) {
    // Заголовок «{name} — Доставка» выставляет DeliveryPage после /settings
    return { title: null, favicon: FAVICONS.delivery };
  }
  if (pathname === '/') {
    return {
      title: 'tez-hop.uz — Цифровое QR меню для ресторанов, отелей, баров',
      favicon: logoPng(),
    };
  }
  if (pathname.startsWith('/menu') || pathname.match(/^\/[a-z0-9-]+$/))
    return { title: 'Меню', favicon: FAVICONS.menu };
  return { title: 'Меню', favicon: FAVICONS.menu };
}

export function usePageMeta(user) {
  const { pathname } = useLocation();

  useEffect(() => {
    const { title, favicon } = getMeta(pathname, user);
    if (title != null) document.title = title;

    let link = document.querySelector('link[rel="icon"][data-dynamic]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.setAttribute('data-dynamic', '1');
      document.head.appendChild(link);
    }
    link.href = favicon;
  }, [pathname, user]);
}
